import { alert } from 'common/components';

import { SlugUtils } from '../utils';

export type Props = {
  modelo:
    | {
        nome: string;
      }
    | undefined;
  onSave: (template: string, fileName: string | undefined) => void;
  onExport: (template: string) => void;
};

export const useExportPdfQuestion = ({ modelo, onSave, onExport }: Props) => {
  const showQuestion = async (
    currentTemplate: string,
    exportBeforeSave: boolean
  ) => {
    const title = exportBeforeSave ? 'Exportar' : 'Salvar';
    const description = exportBeforeSave
      ? 'Deseja salvar o modelo como anexo? Se sim, informe o nome que o pdf receberá.'
      : 'Deseja informar o nome que o pdf receberá?';

    return alert({
      type: 'question',
      title,
      text: description,
      input: 'text',
      inputValidator: (value: string) => {
        if (!value) return 'O nome do pdf é obrigatório';

        if (!SlugUtils.isValidSlug(value)) {
          return `O Nome do pdf não pode possuir caracteres especiais, sugestão: ${SlugUtils.slugify(
            value
          )}`;
        }

        return null;
      },
      onConfirm: (value: string) => {
        const promises = [onSave(currentTemplate, value)];
        if (exportBeforeSave) promises.push(onExport(currentTemplate));
        return Promise.all(promises);
      },
      onCancel: () =>
        exportBeforeSave
          ? onExport(currentTemplate)
          : onSave(currentTemplate, modelo?.nome)
    });
  };

  return showQuestion;
};
